import classes from '../styles/Page.module.scss';
import client from './api/graphql';
import { GET_LEGAL_CONTENT } from './api/graphql/queries';
import Markdown from 'markdown-to-jsx';
import PageHeader from '../components/organisms/pageHeader/PageHeader';

/**
 * Ayoba Web Terms & Conditions Page
 *
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const TermsAndConditions = (props) => {
    /**
     * Section content
     */
    const { termsAndConditions } = props?.data;
    const { copy } = termsAndConditions?.data?.attributes;
    const page_details = termsAndConditions?.data?.attributes.page_header;

    return (
        <div className={classes.oLegal}>
            <PageHeader {...page_details} />
            <div className={`container`}>
                <div className={`row`}>
                    <div className={`col-12`}>
                        <Markdown className={`${classes.aCopyText} fnt16f`}>{copy}</Markdown>
                    </div>
                </div>
            </div>
        </div>
    );
};

export async function getServerSideProps(context) {
    const locale = context.query?.lang || context.defaultLocale;

    const { data } = await client.query({
        query: GET_LEGAL_CONTENT,
        variables: { _locale: locale }
    });

    return {
        props: { data }
    };
}

export default TermsAndConditions;
